import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useChatWindowStore = defineStore('chatWindow', () => {
  const openThreads = ref<{ threadId: number; minimized: boolean }[]>([]);

  function openThread(threadId: number) {
    if (!openThreads.value.find(t => t.threadId === threadId)) {
      openThreads.value.push({ threadId, minimized: false });
    } else {
      bringToFront(threadId);
    }
  }

  function closeThread(threadId: number) {
    openThreads.value = openThreads.value.filter(t => t.threadId !== threadId);
  }

  function minimizeThread(threadId: number) {
    const thread = openThreads.value.find(t => t.threadId === threadId);
    if (thread) {
      thread.minimized = true;
    }
  }

  function maximizeThread(threadId: number) {
    const thread = openThreads.value.find(t => t.threadId === threadId);
    if (thread) {
      thread.minimized = false;
    }
  }

  function bringToFront(threadId: number) {
    const index = openThreads.value.findIndex(t => t.threadId === threadId);
    if (index !== -1) {
      const [thread] = openThreads.value.splice(index, 1);
      openThreads.value.push(thread);
      thread.minimized = false;
    }
  }

  return {
    openThreads,
    openThread,
    closeThread,
    minimizeThread,
    maximizeThread,
    bringToFront,
  };
}, {
  persist: {
    storage: sessionStorage,
  },
});